var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _filter, _filter2, _filter3, _filter4, _filter5, _filter6, _filter7, _filter8, _filter9, _filter10, _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteVip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "vip_pro_prefix__a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "84.235%",
    stopColor: "#FFF"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "vip_pro_prefix__d"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "6.429%",
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "69.779%",
    stopColor: "#E4E4E4"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.719,
    y1: 0.164,
    x2: 0.523,
    y2: 0.847,
    id: "vip_pro_prefix__f"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "83.349%",
    stopColor: "#DCDCDC"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.719,
    y1: 0.164,
    x2: 0.52,
    y2: 0.846,
    id: "vip_pro_prefix__h"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95.191%",
    stopColor: "#DFDFDF"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.5,
    y1: 0,
    x2: 0.5,
    y2: 1,
    id: "vip_pro_prefix__j"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "3.571%",
    stopColor: "#CECECE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "63.306%",
    stopColor: "#DCDCDC"
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.613,
    y1: 0,
    x2: 0.498,
    y2: 1,
    id: "vip_pro_prefix__l"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EDEDED"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.613,
    y1: 0,
    x2: 0.497,
    y2: 1,
    id: "vip_pro_prefix__n"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FAFAFA"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.547,
    y1: 0.047,
    x2: 0.678,
    y2: 0.789,
    id: "vip_pro_prefix__p"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95.714%",
    stopColor: "#E7E7E7"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.547,
    y1: 0.047,
    x2: 0.677,
    y2: 0.789,
    id: "vip_pro_prefix__r"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "92.143%",
    stopColor: "#797979"
  }))), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.612,
    y1: 0.562,
    x2: 0.47,
    y2: 0.288,
    id: "vip_pro_prefix__t"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50.712%",
    stopColor: "#FFEEC2",
    stopOpacity: 0
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    x1: 0.214,
    y1: 0.08,
    x2: 0.825,
    y2: 0.424,
    id: "vip_pro_prefix__v"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFF8E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "53.801%",
    stopColor: "#FFEFC0",
    stopOpacity: 0
  }))), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "vip_pro_prefix__c",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.134,
    y: -0.153,
    width: 1.269,
    height: 1.306
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.167,
    result: "effect1_foregroundBlur"
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "vip_pro_prefix__e",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.162,
    y: -0.153,
    width: 1.325,
    height: 1.305
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.167,
    result: "effect1_foregroundBlur"
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "vip_pro_prefix__g",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.162,
    y: -0.153,
    width: 1.323,
    height: 1.307
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.167,
    result: "effect1_foregroundBlur"
  }))), _filter4 || (_filter4 = /*#__PURE__*/React.createElement("filter", {
    id: "vip_pro_prefix__i",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.134,
    y: -0.108,
    width: 1.269,
    height: 1.216
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.167,
    result: "effect1_foregroundBlur"
  }))), _filter5 || (_filter5 = /*#__PURE__*/React.createElement("filter", {
    id: "vip_pro_prefix__k",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.203,
    y: -0.205,
    width: 1.406,
    height: 1.41
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.167,
    result: "effect1_foregroundBlur"
  }))), _filter6 || (_filter6 = /*#__PURE__*/React.createElement("filter", {
    id: "vip_pro_prefix__m",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.204,
    y: -0.207,
    width: 1.408,
    height: 1.414
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.167,
    result: "effect1_foregroundBlur"
  }))), _filter7 || (_filter7 = /*#__PURE__*/React.createElement("filter", {
    id: "vip_pro_prefix__o",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.116,
    y: -0.102,
    width: 1.231,
    height: 1.204
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.167,
    result: "effect1_foregroundBlur"
  }))), _filter8 || (_filter8 = /*#__PURE__*/React.createElement("filter", {
    id: "vip_pro_prefix__q",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.116,
    y: -0.102,
    width: 1.232,
    height: 1.204
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.167,
    result: "effect1_foregroundBlur"
  }))), _filter9 || (_filter9 = /*#__PURE__*/React.createElement("filter", {
    id: "vip_pro_prefix__s",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.457,
    y: -0.29,
    width: 1.915,
    height: 1.581
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.667,
    result: "effect1_foregroundBlur"
  }))), _filter10 || (_filter10 = /*#__PURE__*/React.createElement("filter", {
    id: "vip_pro_prefix__u",
    filterUnits: "objectBoundingBox",
    colorInterpolationFilters: "sRGB",
    x: -0.078,
    y: -0.187,
    width: 1.157,
    height: 1.374
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.167,
    result: "effect1_foregroundBlur"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "vip_pro_prefix__b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "objectBoundingBox"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.431 3.863a.5.5 0 00.059.579l5.137 5.835a.5.5 0 00.751 0L11.51 4.44a.5.5 0 00.056-.582l-1.348-2.313a.5.5 0 00-.432-.248H2.192a.5.5 0 00-.434.251L.43 3.863z",
    fill: "url(#vip_pro_prefix__a)"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M.43 3.863a.5.5 0 00.06.579l5.137 5.835a.5.5 0 00.75 0L11.51 4.44a.5.5 0 00.057-.582l-1.348-2.313a.5.5 0 00-.432-.248H2.19a.5.5 0 00-.433.251L.43 3.863z",
    fill: "#F7F7F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#vip_pro_prefix__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 0 9.075)",
    filter: "url(#vip_pro_prefix__c)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.522 4.556l2.472 4.342 2.486-4.36-4.958.018z",
    fill: "url(#vip_pro_prefix__d)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#vip_pro_prefix__e)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.994.177L8.48 4.542l1.618-3.294L5.994.178z",
    fill: "url(#vip_pro_prefix__f)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#vip_pro_prefix__g)",
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.871 1.23l1.652 3.292L5.994.178 1.871 1.23z",
    fill: "url(#vip_pro_prefix__h)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#vip_pro_prefix__i)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.52 4.519l2.482 6.184 2.477-6.166-2.48-.018H3.52z",
    fill: "url(#vip_pro_prefix__j)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 0 9.075)",
    filter: "url(#vip_pro_prefix__k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.48 4.538l1.596 3.25 1.684-2.883-3.28-.367z",
    fill: "url(#vip_pro_prefix__l)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 -1 0 9.035)",
    filter: "url(#vip_pro_prefix__m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.256 4.866l1.65 2.873 1.617-3.224-3.267.35z",
    fill: "url(#vip_pro_prefix__n)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#vip_pro_prefix__o)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.24 4.172l5.768 6.541L3.52 4.518.24 4.172z",
    fill: "url(#vip_pro_prefix__p)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1 0 0 1 23.497 0)",
    filter: "url(#vip_pro_prefix__q)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.749 4.17l5.748 6.535-2.468-6.167-3.28-.368z",
    fill: "url(#vip_pro_prefix__r)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#vip_pro_prefix__s)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.856 5.674l-4.18 4.617.74.67 4.181-4.615q.846-.934.973-2.187.127-1.253-.514-2.337l-.376-.636-.86.509.376.636q.473.801.38 1.727-.095.926-.72 1.616z",
    fillRule: "evenodd",
    fill: "url(#vip_pro_prefix__t)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#vip_pro_prefix__u)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.554 1.587h-6.56l-.746 1.375-.372.688-.187.344-.314.586-.25-.14-.078-.18.328-.61.2-.368.4-.736.798-1.472 6.781-.056v.569z",
    fillRule: "evenodd",
    fill: "url(#vip_pro_prefix__v)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteVip);
export default __webpack_public_path__ + "static/media/whiteVip.429f3104.svg";
export { ForwardRef as ReactComponent };